import './styles.scss'
import React from 'react'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'

const FormSteps = (props) => {
  const { step } = props
  const getActiveForStep = (step, stepNumber) => {
    return step === stepNumber ? 'current' : step >= stepNumber ? 'active' : ''
  }
  return (
    <ul className='form-steps text-center form-steps-overview'>
      <li className={getActiveForStep(step, 1)} id='step1'>
        {`${I18n.t('dashboard_verify')}\n${I18n.t('overview_step_check_account')}`}
        <span className='icon' />
      </li>
      <li className={getActiveForStep(step, 2)} id='step2'>
        {`${I18n.t('overview_step_channel_1')}\n${I18n.t('overview_step_channel_2')}`}
        <span className='icon' />
      </li>
      <li className={getActiveForStep(step, 3)} id='step3'>
        {`${I18n.t('overview_step_payment_1')}\n${I18n.t('overview_step_payment_2')}`}
        <span className='icon' />
      </li>
    </ul>
  )
}

export default connect()(FormSteps)
